import React from "react"
import PropTypes from "prop-types"
//import { Link } from "gatsby";
import Link from "../Link"

import { withStyles } from "@material-ui/core/styles"
import Grid from "@material-ui/core/Grid"
import Hidden from "@material-ui/core/Hidden"
import Container from "@material-ui/core/Container"

import Typography from "../LandingComponents/Typography"
import Button from "../LandingComponents/Button"

//import cardBackground from "../../../content/assets/pubGrid.jpg"
import cardBackground from "../../../content/assets/slide-tag-cloud.png"

const styles = (theme) => ({
  root: {
    //marginTop: theme.spacing(18),
    marginBottom: theme.spacing(0),
    display: "flex",
    backgroundColor: theme.palette.secondary.light,
    overflow: "hidden",
  },
  container: {
    marginTop: theme.spacing(10),
    marginBottom: theme.spacing(15),
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  cardWrapper: {
    zIndex: 1,
  },
  card: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: theme.palette.secondary.light,
    padding: theme.spacing(3, 3),
  },
  cardContent: {
    maxWidth: 400,
  },
  button: {
    width: "100%",
  },
  imagesWrapper: {
    position: "relative",
  },
  image: {
    position: "absolute",
    top: 0,
    left: 10,
    right: 0,
    bottom: 0,
    width: "100%",
    maxWidth: 450,
    maxHeight: "310px",
  },
})

const LandingFancyCard = ({ classes }) => (
  <section className={classes.root}>
    <Container className={classes.container}>
      <Grid container>
        <Grid item xs={12} md={6} className={classes.cardWrapper}>
          <div className={classes.card}>
            <div className={classes.cardContent}>
              <Typography variant="h2" component="h2" gutterBottom>
                Publications
              </Typography>
              <Typography variant="h5">
                Our work have been published and featured in top-tier
                international computer science conferences and journals
              </Typography>
              <br />
              <Button
                color="primary"
                variant="contained"
                className={classes.button}
                component={Link}
                to={`/publications`}
              >
                View Publications
              </Button>
            </div>
          </div>
        </Grid>
        <Grid item xs={12} md={6} className={classes.imagesWrapper}>
          <Hidden smDown>
            <Link to={`/publications`}>
              <img
                src={cardBackground}
                alt="publicationsImg"
                className={classes.image}
              />
            </Link>
          </Hidden>
        </Grid>
      </Grid>
    </Container>
  </section>
)

LandingFancyCard.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(LandingFancyCard)
